var _SCROLLING_ICONS;

import React from 'react';
import { bgImageScrollings, sizes } from "../../../../enums";
import Label from "../../../core/label";
import IconMenu from "../../../core/icon-menu";

function MediaSettingsScrollMenu(_ref) {
  var onChange = _ref.onChange,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? bgImageScrollings.SCROLL : _ref$value,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Image scroll' : _ref$label;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Label, {
    text: label,
    style: {
      paddingRight: 0
    }
  }), /*#__PURE__*/React.createElement(IconMenu, {
    id: "attachment",
    items: SCROLLING_OPTIONS,
    activeValue: value,
    size: sizes.X5,
    onItemClick: onChange
  }));
}
/** ########################################################################################
    PRIVATE HELPERS
    ######################################################################################## */


var SCROLLING_ICONS = (_SCROLLING_ICONS = {}, _SCROLLING_ICONS[bgImageScrollings.FIXED] = /*#__PURE__*/React.createElement("svg", {
  id: "bg-attachment-fixed",
  width: "50",
  height: "50",
  viewBox: "0 0 49 49",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  id: "Components",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon-block-element",
  fill: "#D3D8DB",
  d: "M0 0h49v49H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon-image-element",
  fill: "#CACED2",
  d: "M7 34.19h35l-7.375-16.73-6.17 7.458L15.87 14z"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon-image-element",
  fill: "#B1B8BE",
  d: "M5 14h39v1H5zM5 9h39v1H5zM5 19h39v1H5zM5 24h39v1H5zM5 29h39v1H5zM5 34h39v1H5zM5 39h39v1H5z"
}))), _SCROLLING_ICONS[bgImageScrollings.SCROLL] = /*#__PURE__*/React.createElement("svg", {
  id: "bg-attachment-scroll",
  width: "50",
  height: "50",
  viewBox: "0 0 49 49",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  id: "Components",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon-block-element",
  fill: "#D3D8DB",
  d: "M0 0h49v49H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon-image-element",
  fill: "#B1B8BE",
  d: "M13 31h24.27l-5.114-11.6-4.28 5.17L19.152 17zM17 11.85c0 .055.01.11.032.163.022.054.054.097.097.13.075.085.172.128.29.128s.215-.042.29-.128l7.157-7.14 7.14 7.14c.087.086.187.13.3.13.113 0 .213-.044.3-.13.074-.075.112-.17.112-.283 0-.114-.04-.213-.114-.3l-7.448-7.43c-.086-.087-.186-.13-.3-.13-.112 0-.206.043-.28.13l-7.45 7.43c-.042.044-.074.092-.096.146-.02.054-.032.102-.032.145zM17 37.42c0-.054.01-.108.032-.162.022-.053.054-.096.097-.13.075-.085.172-.128.29-.128s.215.043.29.13l7.157 7.14 7.14-7.14c.087-.087.187-.13.3-.13.113 0 .213.043.3.13.074.075.112.17.112.282 0 .113-.04.213-.114.3l-7.448 7.43c-.086.086-.186.13-.3.13-.112 0-.206-.044-.28-.13l-7.45-7.43c-.042-.044-.074-.093-.096-.147-.02-.053-.032-.102-.032-.145z"
}))), _SCROLLING_ICONS);
var SCROLLING_OPTIONS = [{
  tooltip: 'Scroll with page',
  value: bgImageScrollings.SCROLL,
  icon: SCROLLING_ICONS[bgImageScrollings.SCROLL]
}, {
  tooltip: 'Fixed position',
  value: bgImageScrollings.FIXED,
  icon: SCROLLING_ICONS[bgImageScrollings.FIXED]
}];
export default MediaSettingsScrollMenu;
//# sourceMappingURL=media-settings-scroll-menu.js.map